import { useEffect } from "react";
import confetti from "canvas-confetti";
import { Screen, ScreenHeader, Display, Eyebrow, Btn, btnIcon } from "../ui/components";
import { Ico } from "../ui/Ico";
import { C, mono } from "../ui/tokens";

export function Success({
  total, currency, items, refId, onAnother, onHome,
}: {
  total: number;
  currency: string;
  items: number;
  refId: string;
  onAnother: () => void;
  onHome: () => void;
}) {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const colors = ["#ffffff", "#D7F756", "#F6C760", "#9DD8FF", "#FF8A6E"];
    const fire = (opts: confetti.Options) =>
      confetti({
        particleCount: 60,
        spread: 70,
        startVelocity: 35,
        gravity: 0.9,
        ticks: 220,
        scalar: 0.9,
        colors,
        ...opts,
      });

    fire({ origin: { x: 0.5, y: 0.45 } });
    setTimeout(() => fire({ angle: 60, spread: 55, origin: { x: 0, y: 0.55 } }), 180);
    setTimeout(() => fire({ angle: 120, spread: 55, origin: { x: 1, y: 0.55 } }), 320);
  }, []);

  return (
    <Screen style={{ display: "flex", flexDirection: "column" }}>
      <ScreenHeader
        right={
          <button onClick={onHome} style={btnIcon} aria-label="Schliessen">
            <Ico name="close" size={18} />
          </button>
        }
      />

      <div style={{
        flex: 1, display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center",
        textAlign: "center", paddingBottom: 60, paddingTop: 40,
      }}>
        <div style={{ position: "relative", width: 140, height: 140, marginBottom: 28 }}>
          {[0, 1, 2].map((n) => (
            <div key={n} style={{
              position: "absolute", inset: -n * 12,
              borderRadius: "50%", border: `1px solid ${C.border}`,
              opacity: 1 - n * 0.3,
              animation: `spepulse 2.5s ease-out ${n * 0.3}s infinite`,
            }} />
          ))}
          <div
            style={{
              position: "absolute", inset: 0, borderRadius: "50%",
              background: C.fg, color: "#000",
              display: "flex", alignItems: "center", justifyContent: "center",
              boxShadow: "0 1px 0 rgba(255,255,255,0.6) inset, 0 20px 60px rgba(255,255,255,0.15)",
              animation: "checkPop 540ms cubic-bezier(0.34, 1.56, 0.64, 1) both",
            }}
          >
            <svg width="64" height="64" viewBox="0 0 24 24">
              <path
                d="M5 12.5l5 5L20 7"
                fill="none" stroke="#000" strokeWidth="2.4"
                strokeLinecap="round" strokeLinejoin="round"
                strokeDasharray="40"
                strokeDashoffset="40"
                style={{
                  animation: "checkStroke 360ms cubic-bezier(0.4, 0, 0.2, 1) 360ms forwards",
                }}
              />
            </svg>
          </div>
        </div>

        <Eyebrow>Erfolgreich eingereicht</Eyebrow>
        <Display style={{ marginTop: 10 }}>Gespeichert</Display>

        <div style={{
          marginTop: 22, padding: "14px 18px",
          borderRadius: 14, background: C.surface, border: `1px solid ${C.border}`,
          display: "flex", gap: 24,
          fontFamily: mono, fontSize: 13,
        }}>
          <div>
            <div style={{ color: C.fg3, fontSize: 10, textTransform: "uppercase", letterSpacing: "0.12em" }}>Pos</div>
            <div style={{ color: C.fg, fontWeight: 600, marginTop: 4 }}>{items}</div>
          </div>
          <div style={{ width: 1, background: C.border }} />
          <div>
            <div style={{ color: C.fg3, fontSize: 10, textTransform: "uppercase", letterSpacing: "0.12em" }}>Total</div>
            <div style={{ color: C.fg, fontWeight: 600, marginTop: 4 }}>{currency} {total.toFixed(2)}</div>
          </div>
          <div style={{ width: 1, background: C.border }} />
          <div>
            <div style={{ color: C.fg3, fontSize: 10, textTransform: "uppercase", letterSpacing: "0.12em" }}>Ref</div>
            <div style={{ color: C.fg, fontWeight: 600, marginTop: 4 }}>#{refId}</div>
          </div>
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 10, paddingBottom: 24 }}>
        <Btn onClick={onAnother} icon={<Ico name="cam" size={18} color="#000" />}>
          Weitere Quittung scannen
        </Btn>
        <Btn kind="ghost" onClick={onHome}>Zurück zur Übersicht</Btn>
      </div>
    </Screen>
  );
}
